module.exports = new Promise((resolve,reject) => {
                              const remoteUrl = window.__CONFIG__.REACT_APP_LTOVFUIEMP_REMOTE_URL;
                              const script = document.createElement('script');
                              script.src = remoteUrl;
                              script.onload = () => {
                              const proxy = {
                                  get: (request) => window.ltovfUiEmp.get(request),
                                  init: (arg) => {
                                  try {
                                    return window.ltovfUiEmp.init(arg);
                                  } catch (e) {
                                    console.warn('ltovfUiEmp remote already initialized');
                                  }
                                }
                              };
                              resolve(proxy);
                              
                            };
                            script.onerror = (err) =>{
                              console.log('Failed to load remote script',err);
                              reject(new Error('Unable to load RemoteEntry file for ltovfUiEmp MFE'));
                            }
                            document.head.appendChild(script);
                      });